<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<h1 class="toc-title">Contents</h1>
<p class="toc"><span href="#/Text/part0001" title="Link target outside of Sample">Copyright</span></p>
<p class="toc" id="chap-1"><a href="#/Text/part0004">The Kowloon Cafe</a></p>
<p class="toc" id="chap-2"><span href="#/Text/part0005" title="Link target outside of Sample">Tulips</span></p>
<p class="toc" id="chap-3"><span href="#/Text/part0006" title="Link target outside of Sample">The Mansions of Federico Juarez</span></p>
<p class="toc" id="chap-4"><span href="#/Text/part0007" title="Link target outside of Sample">Japanese Baseball</span></p>
<p class="toc" id="chap-5"><span href="#/Text/part0008" title="Link target outside of Sample">The Indestructible Hadrian Wilks</span></p>
<p class="toc" id="chap-6"><span href="#/Text/part0009" title="Link target outside of Sample">The First and Last Annual Six Towns Area Old-Timers’ Game</span></p>
<p class="toc" id="chap-7"><span href="#/Text/part0010" title="Link target outside of Sample">The Lime Tree</span></p>
<p class="toc" id="chap-8"><span href="#/Text/part0011" title="Link target outside of Sample">The Arbiter</span></p>
<p class="toc" id="chap-9"><span href="#/Text/part0012" title="Link target outside of Sample">Fred Noonan Flying Services</span></p>
<p class="toc" id="chap-10"><span href="#/Text/part0013" title="Link target outside of Sample">Wavelengths</span></p>
<p class="toc" id="chap-11"><span href="#/Text/part0014" title="Link target outside of Sample">Underestimating Lynn Johanssen</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0002.vue?0e613df4